import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { ReactTableDefaults } from "react-table";
import ReactTable from "react-table";
import TooltipDescricaoErro from "../../Componente/Common/TooltipDescricaoErro";
import HeaderResultado from "./HeaderResultado";
import HttpUtil from "../../Util/httpUtil";
import ResultadoExpandido from "./ResultadoExpandido";
import TabelaDfe from "./TabelaDfe";
import TabelaICMS from "./TabelaICMS";
import Config from "../../Util/config";

import "../../_Content/css/resultado.css";
import "../../_Content/css/eco-template.css";

Object.assign(ReactTableDefaults, {
	nextText: "Proxíma",
	previousText: "Anterior",
	noDataText: "Nenhum resultado encontrado",
	pageText: "Pag.",
	ofText: "de",
	loadingText:"Carregando...",
});

const idUsuario = localStorage.getItem("CodUsuario");
const administrador = localStorage.getItem("Administrador") === 'true';

let qtdeErrosPerfil = 0;
let qtdeAvisosPerfil = 0;
let qtdeAlertasPerfil = 0;
let qtdeErros = 0;
let qtdeAvisos = 0;
let qtdeAlertas = 0;

class Resultado extends Component {

	constructor(props) {

		super(props);
		this.state = {
			lista: [],
			data: [],
			cpfcnpj: '',
			dtInicio: '',
			dtFim: '',
			moduloEfd: this.props.params.moduloEfd,
			idArquivo: this.props.params.idArquivo,
			tpValidacao: this.props.params.tpValidacao,
			bloquearFiltrosInativos: this.props.params.bloquearFiltrosInativos,
			listaFiltrada: [],
			listaErrosPerfil: [],
			listaDfe: [],
			listaDfeFiltrada: [],
			listaICMS: [],
			mensagemErroICMS: '',
			icmsStep: 1,
			totalNotas: 0,
			stateErrosBasica: 0,
			showAnaliseDFe: true,
			showAbas: 'RESULTADO',
			showLoadingDFe: false,
			stateErrosInteligente: 0,
			colunas: [
				{
					Header: "Registro",
					accessor: "REGISTRO",
					className: "text-center txt",
					maxWidth: 90
				},
				{
					Header: "Quantidade",
					accessor: "QUANTIDADE",
					className: "text-center txt",
					maxWidth: 90
				},
				{
					Header: "Campo",
					className: "text-center txt",
					maxWidth: 150,
					Cell: row => (
						<span>{`${row.original.NUMERO_CAMPO} - ${row.original.CAMPO}`}</span>
					)
				},
				{
					Header: "Validação",
					id: "2021",
					accessor: "ORIGEM",
					className: "text-center valBts",
					maxWidth: 150,
					Cell: row => (
						<span
							className={
								row.value == "basica"
									? "ecobtn fit cinza"
									: row.value == "inteligente"
										? "ecobtn fit azul-ceu"
										: "ecobtn fit azul-marinho"
							}
						>
							<TooltipDescricaoErro id={"v_" + row.index} 
								ToolTipText={row.value == "basica"
										? "Validações efetuadas com base no Guia Prático e no PVA."
										: row.value == "inteligente"
										? "Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet)."
										: ""}
								text={row.value == "basica"
										? "Básica"
										: row.value == "inteligente"
										? "Inteligente"
										: row.value == "estrutura" ? "Estrutura" : "Estados"} 
							/>
						</span>
					)
				},
				{
					Header: "Descrição da regra",
					accessor: "MENSAGEM",
					className: "txt",
					Cell: row => <TooltipDescricaoErro id={row.index} text={row.value} />
				},
				{
					Header: "Ocorrência",
					accessor: "OCORRENCIA",
					className: "text-center",
					show: administrador,
					maxWidth: 80,
				},
				{
					Header: "Tipo",
					accessor: "TIPO",
					className: "text-center",
					maxWidth: 130,
					Cell: row => (
						<div className="erroTp">
							<i
								className={
									row.value == "Aviso"
										? "ecoico ecoico-aviso pr-2"
										: row.value == "Erro"
											? "ecoico ecoico-erro pr-2"
											: "ecoico ecoico-nao-realizada pr-2"
								}
							/>
							<span Style="align-self: center">
								{row.value == "Aviso"
									? "Avisos"
									: row.value == "Erro"
										? "Erro"
										: "Alerta"}
							</span>
						</div>
					)
				},
				{
					expander: true,
					className: "colBtns",
					width: 130,
					Expander: ({ isExpanded, ...rest }) => (
						<div>
							{isExpanded ? (
								<button
									style={{ width: "85px" }}
									className="ecobtn fit azul-ceu"
								>
									Fechar
								</button>
							) : (
									<button
										style={{ width: "85px" }}
										className="ecobtn fit vazado azul-ceu"
									>
										Expandir
								</button>
								)}
						</div>
					)
				}
			],
			loading: true,
			totalErros: 0,
			quantidadeErros: 0,
			quantidadeAlertas: 0,
			quantidadeAvisos: 0,
			totalErrosPerfil: 0,
			showDfe: false,
			dfeIsReady: false,
			emitCpfCnpj: undefined, 
			emitDtInicio: undefined, 
			emitDtFim: undefined,
			emitIdArquivo: undefined,
			emitIdUsuario: undefined,
			ufsComProblemas: undefined,
			flagMostrarDivPorDemora: false,
		};
		this.setShowAbas = this.setShowAbas.bind(this);
		this.prepararRequestData();
	}

	static contextTypes = {
		router: () => true
	};

	setShowAbas = (aba) => {
		this.setState(() => ({
			showAbas: aba
		}))
	};
	setHideDfe = () => {
		this.setState(() => ({
			showDfe: false
		}))
	};

	// setcpfcnpj = (emitCpfCnpj, emitDtInicio, emitDtFim) => {
	// 	this.analiseDfe(emitCpfCnpj, emitDtInicio, emitDtFim)
	// 	.then((res) => {
	// 		let totalNFeErros = 0;
	// 		res.rows.DocumentosDFe.forEach(i => {
	// 			if (i.ValoresDocumento.length > 0) {
	// 				totalNFeErros++
	// 			}
	// 		});
	// 		this.setState({ 
	// 			listaDfe: res.rows,
	// 			listaDfeFiltrada: res.rows.DocumentosDFe.filter(i => i.ValoresDocumento.length > 0),
	// 			totalNotas: totalNFeErros,
	// 		})
	// 	})
	// }

	onRedirect = () => {
		this.history.goBack;
	};

	onLoading = isLoading => {
		this.setState({ loading: isLoading });
	};

	subComponentMapper = row => {
		return (
			<div>
				<ResultadoExpandido
					color={row.index % 2 == 0 ? "#ffffff" : "#eef3f5"}
					id_arquivo={row.original.ID_ARQUIVO}
					registro={row.original.REGISTRO}
					campo={row.original.CAMPO}
					ocorrencia={row.original.OCORRENCIA}
					legislacao={row.original.LEGISLACAO}
					mensagem={row.original.MENSAGEM}
                    particularidades={row.original.PARTICULARIDADES}
					sugestao={row.original.SUGESTAO}
					quantidadeErros={row.original.QUANTIDADE}
					moduloEfd={this.state.moduloEfd}
					numNotaFiscal={row.original.NUMERO_NOTA_FISCAL}
				/>
			</div>
		);
	};

	alterarStatusFiltro = (
		basicaHabilitado,
		inteligenteHabilitada,
		perfilHabilitado,
		errosHabilitados,
		alertasHabiltiados,
		avisosHabilitados
	) => {
		let listaTemporaria = [];
		let numeroRegistros = 1;
		let quantidadeDeErros = 0;
		if (perfilHabilitado) {
			listaTemporaria = this.state.listaErrosPerfil;
			numeroRegistros = Object.keys(this.state.listaErrosPerfil).length;
			quantidadeDeErros = this.state.totalErrosPerfil;
		} else if (
			(this.state.tpValidacao == "basica" && inteligenteHabilitada) ||
			(this.state.tpValidacao == "inteligente" && basicaHabilitado)
		) {
			this.state.tpValidacao = "basica,inteligente";
			//this.revalidarArquivo();
			return;
		} else if (!inteligenteHabilitada && !basicaHabilitado) {
			numeroRegistros = 1;
		} else {
			let novaLista = [];
			let quantidadeErros = 0;
			for (let indice in
				this.state.lista) {
				if (this.state.lista[indice].ORIGEM == "basica" && basicaHabilitado) {
					novaLista.push(this.state.lista[indice]);
					quantidadeErros += this.state.lista[indice].QUANTIDADE;
				} else if (
					this.state.lista[indice].ORIGEM == "inteligente" &&
					inteligenteHabilitada
				) {
					novaLista.push(this.state.lista[indice]);
					quantidadeErros += this.state.lista[indice].QUANTIDADE;
				}
			}

			this.quantificarErros(
				novaLista,
				false,
				(quantidadeErros, quantidadeErrosPerfil, errosPerfil, listaTemp) => {
					listaTemporaria = listaTemp;
					numeroRegistros = Object.keys(listaTemp).length;
					quantidadeDeErros = quantidadeErros;
				}
			);
		}
		if (!(errosHabilitados && alertasHabiltiados && avisosHabilitados)) {
			let novaListaDivergencia = [];
			let quantidadeErrosDivergencia = 0;

			for (let indice in
				listaTemporaria) {
				if (
					(listaTemporaria[indice].TIPO == "Aviso" && avisosHabilitados) ||
					(listaTemporaria[indice].TIPO == "Erro" && errosHabilitados) ||
					(listaTemporaria[indice].TIPO == "Alerta" && alertasHabiltiados)
				) {
					novaListaDivergencia.push(listaTemporaria[indice]);
					quantidadeErrosDivergencia += listaTemporaria[indice].QUANTIDADE;
				}
			}
			listaTemporaria = novaListaDivergencia;
			numeroRegistros = Object.keys(novaListaDivergencia).length;
			quantidadeDeErros = quantidadeErrosDivergencia;
		}
		this.setState({
			listaFiltrada: listaTemporaria,
			totalErros: quantidadeDeErros,
			quantidadeErros: perfilHabilitado ? qtdeErrosPerfil : qtdeErros,
			quantidadeAlertas: perfilHabilitado ? qtdeAlertasPerfil : qtdeAlertas,
			quantidadeAvisos: perfilHabilitado ? qtdeAvisosPerfil : qtdeAvisos
		});
	};

	requestData = () => {
		return new Promise((resolve, reject) => {
			let urlApi =
				this.state.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL
				: this.state.moduloEfd === "ECF" ? Config.urls.API_URL_ECF
				: this.state.moduloEfd === "ECD" ? Config.urls.API_URL_ECD
				: Config.urls.API_URL_CONT;

			let url = `${urlApi}Validacao/ExibirResultado/${this.state.idArquivo}/${this.state.tpValidacao}`;
			HttpUtil.eco_GET(
				url,
				response => {
					resolve({ rows: response.data });
				},
				() => {
					console.log("Error: Exibir Erros Estrutura", this.state.moduloEfd);
				}
			);
		});
	};

	analiseDfe = (cpfCnpj, dtInicio, dtFim) => {
		if (this.state.moduloEfd === "Fiscal") {
			const newDtIni = dtInicio.split('/').reverse().join('-')
			const newDtFim = dtFim.split('/').reverse().join('-')
			return new Promise((resolve, reject) => {
				let url = `${Config.urls.API_URL_FISCAL}Validacao/BuscarDocumentosDFe/${this.state.idArquivo}/${idUsuario}/${cpfCnpj}/${newDtIni}/${newDtFim}`
				// let url = `${Config.urls.API_URL_FISCAL}Validacao/BuscarDocumentosDFe/5159/110375/28418499000170/2024-01-01/2024-01-31`
				HttpUtil.eco_GET(
					url,
					response => {
						resolve({ rows: response.data });

					},
					() => {
						console.log("Erro ");
					}
				);
			})
		}
	}

	validarArquivos = () => {
		return new Promise((resolve, reject) => {
			let urlApi =
				this.state.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL
				: this.state.moduloEfd === "ECF" ? Config.urls.API_URL_ECF 
				: this.state.moduloEfd === "ECD" ? Config.urls.API_URL_ECD 
				:  Config.urls.API_URL_CONT;

			let url = `${urlApi}Validacao/Validar/${this.state.idArquivo}/${idUsuario}/inteligente`;
			HttpUtil.eco_GET(
				url,
				response => { resolve({ rows: response.data }); },
				() => {
					console.log("Error ExibirErrosEstrutura");
				}
			);
		});
	}

	RedefinirParametro = () => {
		return new Promise((resolve, reject) => {
			let urlApi =
				this.state.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL
				: this.state.moduloEfd === "ECF" ? Config.urls.API_URL_ECF 
				: this.state.moduloEfd === "ECD" ? Config.urls.API_URL_ECD 
				:  Config.urls.API_URL_CONT;

			let url = `${urlApi}Validacao/RedefinirParametros/${this.state.idArquivo}/${this.state.tpValidacao}`;
			HttpUtil.eco_GET(
				url,
				response => { resolve({ rows: response.data }); },
				() => {
					console.log("Error ExibirErrosEstrutura");
				}
			);
		});
	}

	prepararRequestData = () => {

		this.requestData().then(res => {
			this.setState({ loading: true });

			this.quantificarErros(
				res.rows,
				true,
				(
					quantidadeErros,
					quantidadeErrosPerfil,
					errosPerfil,
					listaTemp,
					tipoErrosPerfil
				) => {
					this.setState({
						lista: res.rows,
						listaFiltrada: listaTemp,
						listaErrosPerfil: errosPerfil,
						loading: false,
						totalErros: quantidadeErros,
						totalErrosPerfil: quantidadeErrosPerfil
					});
				}
			);
		});
	};

	revalidarArquivo = () => {
		this.setState({ loading: true });
		this.RedefinirParametro().then(res => {
			this.validarArquivos().then(res2 => {
				this.setState({ loading: false });
				this.prepararRequestData();
			});
		});
	};

	setPropsDFe = (emitCpfCnpj, emitDtInicio, emitDtFim) => {
		this.setState(() => ({
			emitCpfCnpj: emitCpfCnpj, 
			emitDtInicio: emitDtInicio, 
			emitDtFim: emitDtFim
		}))
	};

	setPropsICMS = (emitIdArquivo, emitIdUsuario) => {
		this.setState(() => ({
			emitIdArquivo: emitIdArquivo, 
			emitIdUsuario: emitIdUsuario
		}))
	};

	changeShowDFe = () => {
		this.setState({
			showLoadingDFe: true
		})
			this.analiseDfe(this.state.emitCpfCnpj, this.state.emitDtInicio, this.state.emitDtFim)
			.then((res) => {
				let totalNFeErros = 0;
				res.rows.DocumentosDFe.forEach(i => {
					if (i.ValoresDocumento.length > 0) {
						totalNFeErros++
					}
				});
				this.setState({ 
					listaDfe: res.rows,
					listaDfeFiltrada: res.rows.DocumentosDFe.filter(i => i.ValoresDocumento.length > 0),
					totalNotas: totalNFeErros,
					showLoadingDFe: false,
					dfeIsReady: true,
				})
			})
			this.forceUpdate();
	}
	
	verificarArquivoIcmsApuracao = () => {
		this.setState({ icmsStep: 0	});
		new Promise((resolve, reject) => {
			let url = `${Config.urls.API_URL_FISCAL}Validacao/IcmsApuracao/Verificacao/${this.state.emitIdArquivo}/${this.state.emitIdUsuario}`;
			HttpUtil.eco_GET(url, (response) => {
				if (response.data.sucesso) {
					this.setState({ icmsStep: 3	});
					setTimeout(() => {
						this.executarIcmsApuracao();
					}, 1000);
				}
				else {
					this.setState({ 
						icmsStep: 2,
						mensagemErroICMS: response.data.mensagem,
						ufsComProblemas: response.data.ufsComProblema,
					});
				}
			}, () => { console.log("Error"); });
		}).then(() => {
		});
	}

	executarIcmsApuracao = () => {
		new Promise((resolve, reject) => {
			let url = Config.urls.API_URL_FISCAL + 'Validacao/IcmsApuracao';

			let data = {
				"idArquivo": this.state.emitIdArquivo,
				"idUsuario": this.state.emitIdUsuario,
				"ufsComProblemas": this.state.ufsComProblemas
			}

			this.mostrarMensagemDemora();

			HttpUtil.eco_POST(url, data, response => {
				if (response.data.sucesso) {
					this.setState({ 
						icmsStep: 4,
						listaICMS: response.data.lstInformacoesDasGuiasIcmsApuracao
					});
				}
				else if ((response.data.sucesso == false) && ((response.data.mensagem == "500") || (response.data.mensagem == "504"))) {
					this.setState({
						icmsStep: -1,
						mensagemErroICMS: response.data.mensagem,
					});
				}
				else {
					this.setState({ 
						icmsStep: 2,
						mensagemErroICMS: response.data.mensagem,
						ufsComProblemas: undefined,
					});
				}
			}, () => { console.log("Error"); });
		}).then(() => {
		});
	}

	mostrarMensagemDemora = () => {
		setTimeout(() => {
			this.setState({ flagMostrarDivPorDemora: true, });
		}, 10000); //método executa a função após dez segundos
	}

	quantificarErros = (listaInteira, analisarOrigem, callback) => {

		let quantidadeErros = 0;
		let quantidadeErrosPerfil = 0;
		let errosPerfil = [];
		let listaTemp = [];
		let qtdErrosBasica = 0;
		let qtdErrosInteligente = 0;

		qtdeAvisosPerfil = 0;
		qtdeErrosPerfil = 0;
		qtdeAlertasPerfil = 0;
		qtdeAvisos = 0;
		qtdeErros = 0;
		qtdeAlertas = 0;		

		// console.log(listaInteira);

		for (let indice in listaInteira) {

			if(analisarOrigem){

				if(listaInteira[indice].ORIGEM === "basica"){
					qtdErrosBasica +=  listaInteira[indice].QUANTIDADE;
				}
	
				if(listaInteira[indice].ORIGEM === "inteligente"){
					qtdErrosInteligente +=  listaInteira[indice].QUANTIDADE;
				}			

			}			

			if (listaInteira[indice].OCORRENCIA.startsWith("P")) {

				errosPerfil.push(listaInteira[indice]);
				quantidadeErrosPerfil += listaInteira[indice].QUANTIDADE;

				if (listaInteira[indice].TIPO == "Aviso") {
					qtdeAvisosPerfil += listaInteira[indice].QUANTIDADE;
				} 
				else if (listaInteira[indice].TIPO == "Erro") {
					qtdeErrosPerfil += listaInteira[indice].QUANTIDADE;
				} 
				else {
					qtdeAlertasPerfil += listaInteira[indice].QUANTIDADE;
				}
			} 

			else {
				listaTemp.push(listaInteira[indice]);
				quantidadeErros += listaInteira[indice].QUANTIDADE;

				if (listaInteira[indice].TIPO == "Aviso") {
					qtdeAvisos += listaInteira[indice].QUANTIDADE;
				} 
				else if (listaInteira[indice].TIPO == "Erro") {
					qtdeErros += listaInteira[indice].QUANTIDADE;
				} 
				else {
					qtdeAlertas += listaInteira[indice].QUANTIDADE;
				}
			}
		}

		this.setState({
			quantidadeErros: qtdeErros,
			quantidadeAlertas: qtdeAlertas,
			quantidadeAvisos: qtdeAvisos,
			stateErrosBasica: analisarOrigem ? qtdErrosBasica : this.state.stateErrosBasica,
			stateErrosInteligente: analisarOrigem ? qtdErrosInteligente : this.state.stateErrosInteligente
		});

		callback(
			quantidadeErros,
			quantidadeErrosPerfil,
			errosPerfil,
			listaTemp
		);
	};

	render() {
		return (
			<Container>
				<Row>
					<Col>
						<div>
							<HeaderResultado
								moduloEfd={this.state.tpValidacao.toLowerCase().includes("simples-nacional") ? "SimplesNacional" : this.state.moduloEfd}
								filtro={true}
								idArquivo={this.state.idArquivo}
								totalReg={this.state.totalErros}
								bloquearFiltrosInativos={this.state.bloquearFiltrosInativos}
								perfilHabilitado={false}
								basicaHabilitado={this.state.tpValidacao.includes("basica")}
								inteligenteHabilitado={this.state.tpValidacao.includes(
									"inteligente"
								)}
								quantidadeErrosPerfil={this.state.totalErrosPerfil}
								action={this.alterarStatusFiltro}
								onRedirect={this.onRedirect}
								quatidadeErros={this.state.quantidadeErros}
								quatidadeAlertas={this.state.quantidadeAlertas}
								quatidadeAvisos={this.state.quantidadeAvisos}
								onLoading={this.onLoading}
								status="Finalizado"
								origem={this.props.params.origem}
								errosBasica={this.state.stateErrosBasica}
								errosInteligente={this.state.stateErrosInteligente}
								setShowAbas={this.setShowAbas}
								setHideDfe={this.setHideDfe}
								cpfcnpj={this.setcpfcnpj}
								totalDfe={this.state.totalNotas}
								setPropsDFe={this.setPropsDFe}
								setPropsICMS={this.setPropsICMS}
								showAbas={this.state.showAbas}
								isFiscal={this.state.moduloEfd === "Fiscal"}
								showLoadingDFe={this.state.showLoadingDFe}
							/>
						</div>
						{this.state.showAbas == 'DFE' ? (
							<TabelaDfe
								showLoadingDFe={this.state.showLoadingDFe}
								buscarDFe={this.changeShowDFe}
								setDataDFE={this.state.listaDfe}
								setDataDFEFiltrado={this.state.listaDfeFiltrada}
								totalDfe={this.state.totalNotas}
								isReady={this.state.dfeIsReady}
							/>
						) :	null}
						{this.state.showAbas == 'ICMS' ? (
							<TabelaICMS
								validarICMS={this.verificarArquivoIcmsApuracao}
								buscarICMS={this.executarIcmsApuracao}
								setDataICMS={this.state.listaICMS}
								setDataDFEFiltrado={this.state.listaDfeFiltrada}
								step={this.state.icmsStep}
								idUsuario={this.state.emitIdUsuario}
								mensagemErro={this.state.mensagemErroICMS}
								ufsComProblemas={this.state.ufsComProblemas}
								flagMostrarDivPorDemora={this.state.flagMostrarDivPorDemora}
							/>
						) :	null}
						{this.state.showAbas == 'RESULTADO' ? (
							<ReactTable
								data={this.state.listaFiltrada}
								columns={this.state.colunas}
								loading={this.state.loading}
								className="eco-react-table"
								SubComponent={this.subComponentMapper}
								showPagination={false}
								pageSize={this.state.listaFiltrada.length}
							/>
						) : null}
					</Col>
				</Row>
			</Container>
		);
	}
}

export default Resultado;



// WEBPACK FOOTER //
// ./src/Componente/Resultado/Resultado.jsx